// extracted by mini-css-extract-plugin
export var main = "_2dedafb88e0601f7821b7b582ed6ea4b-css";
export var main_invalid = "_84b68740868c7fd4ee353c538d85645f-css";
export var iconWrap = "_3f8ba6958e7473c2cf2a128de6877bd6-css";